import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { workflowKeys } from './workflowKeys';

export function useUnpublishWorkflow() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: (workflowId: string) =>
      apiClient.post(`api/v1/t/${tenantId}/workflows/${workflowId}/unpublish`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: workflowKeys.lists() });
    },
  });
}
